import { Tooltip, type TooltipProps } from 'antd';
import cs from 'classnames';
import Styles from './Styles.module.scss';

export function MPTooltip({ className, title, children, overlayClassName, show = true, ...props }: MPTooltipProps) {
    if (show) {
        return (
            <Tooltip
                title={title}
                className={className}
                color="white"
                styles={{ container: { color: '#364153' } }}
                classNames={{ root: cs(Styles.Tooltip, overlayClassName) }}
                {...props}
            >
                {children}
            </Tooltip>
        );
    }

    return <>{children}</>;
}

export interface MPTooltipProps extends TooltipProps {
    className?: string;
    overlayClassName?: string;
    show?: boolean;
}
